'use client'

import { cx } from '@/lib/utils'

import type { LicenseMapCategoryLabels, LicenseMapJurisdiction } from './license-map-types'
import type { LicenseMapTooltipAnchor } from './use-license-map-tooltip'

interface LicenseMapTooltipProps {
  anchor: LicenseMapTooltipAnchor | null
  row: LicenseMapJurisdiction | undefined
  categoryLabels: LicenseMapCategoryLabels
  viewSourceLabel: string
  onMouseEnter: () => void
  onMouseLeave: () => void
}

// Always mounted (so the live region exists before its content changes);
// `tip-on` shows it. Positioned by license-map.css relative to the widget root.
export const LicenseMapTooltip = ({
  anchor,
  row,
  categoryLabels,
  viewSourceLabel,
  onMouseEnter,
  onMouseLeave,
}: LicenseMapTooltipProps) => (
  <div
    className={cx('tip', anchor && 'tip-on', anchor?.below && 'tip-below')}
    role="status"
    aria-live="polite"
    style={anchor ? { left: anchor.x, top: anchor.y } : undefined}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {row && (
      <>
        <div className="text-[14px] font-bold">{row.name}</div>
        <div className="mb-1 text-[11px] tracking-wider uppercase opacity-75">{categoryLabels[row.category]}</div>
        <div className="opacity-90">{row.detail}</div>
        {row.source && (
          <a
            href={row.source}
            target="_blank"
            rel="noopener nofollow"
            data-tracking="ignore"
            className="text-sky mt-1.5 inline-block underline"
          >
            {viewSourceLabel}
            <span aria-hidden="true"> →</span>
          </a>
        )}
      </>
    )}
  </div>
)
